

import { getAuthMePath } from '../routing/paths';




export const DEFAULT_IDENTITY_TIMEOUT_MS = 10000;

export async function fetchIdentity(timeoutMs = DEFAULT_IDENTITY_TIMEOUT_MS) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);

    try {
        const response = await fetch(getAuthMePath(), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: controller.signal
        });

        if (response.status === 200) {
            const body = await response.json();
            
            
            
            const { sid = null, ...identity } = body;
            return { authenticated: true, identity, sid };
        }

        return { authenticated: false, identity: null, sid: null };
    } finally {
        clearTimeout(timer);
    }
}
